export class AddressState
{
	countryId = "";
	code = "";
	name = "";
	level = "";
	countryCode = "";
	countryAlpha3Code = "";
	countryName = "";
}


// WEBPACK FOOTER //
// ./src/models/AddressState.ts